/** Antwort von POST /api/leads/:id/merge-into (RPC merge_project). */
export type MergeProjectResult = {
  merge_id: string;
  target_id: string;
  target_display_id: string | null;
  counts: Record<string, number>;
};

const LABELS: Array<[key: string, singular: string, plural: string]> = [
  ['offerings', 'Vorgang', 'Vorgänge'],
  ['lead_activities', 'Termin', 'Termine'],
  ['lead_documents', 'Dokument', 'Dokumente'],
  ['invoice_documents', 'Rechnung', 'Rechnungen'],
  ['employee_time_entries', 'Ist-Zeit', 'Ist-Zeiten'],
  ['tasks', 'Aufgabe', 'Aufgaben'],
  ['inbox_emails', 'E-Mail', 'E-Mails'],
];

/** Kurzfassung für den Erfolgs-Toast, z. B. „2 Vorgänge, 1 Termin, 4 Dokumente“. */
export function mergeProjectSummary(counts: Record<string, number> | null | undefined): string {
  const parts = LABELS.flatMap(([key, singular, plural]) => {
    const n = Number(counts?.[key] ?? 0);
    return n > 0 ? [`${n} ${n === 1 ? singular : plural}`] : [];
  });
  return parts.join(', ');
}
